import { ThemeProvider } from '@mui/material/styles';
import Base from 'pages/Base/Base';
import { useState } from 'react';
import { theme } from '../../components/layouts/theme';
import { ApprovalEmailModal } from './ApprovalEmailModal';
import { ConfirmationModal } from './ConfirmationModal';
import { PendingApprovalsTable } from './PendingApprovalsTable';
import { ResultsModal } from './ResultsModal';

/**
 * React component housing all the necessary components used for the `Pending Approvals` page.
 * @returns React component.
 */
const PendingApprovals = () => {
	// For table
	const [refreshTableValue, setRefreshTableValue] = useState(0); // Uses state change to force refresh table
	const [loadingTableValue, setLoadingTableValue] = useState(0); // Uses state change to force refresh table

	// For ApprovalEmailModal
	const [navigateUrl, setNavigateUrl] = useState();
	const [approvalEmailOpen, setApprovalEmailOpen] = useState(false);

	// For ConfirmationModal
	const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);

	// For ResultsModal
	const [resultsModalOpen, setResultsModalOpen] = useState(false);
	const [resultsRows, setResultsRows] = useState([]);

	// Return React component
	return (
		<ThemeProvider theme={theme}>
			<Base title={'Requests Awaiting My Approval'}>
				<PendingApprovalsTable
					setNavigateUrl={setNavigateUrl}
					setApprovalEmailOpen={setApprovalEmailOpen}
					setConfirmationModalOpen={setConfirmationModalOpen}
					externalRefreshValue={refreshTableValue}
					externalLoadingValue={loadingTableValue}
				/>

				<ApprovalEmailModal
					navigateUrl={navigateUrl}
					approvalEmailOpen={approvalEmailOpen}
					setApprovalEmailOpen={setApprovalEmailOpen}
					refreshTable={() =>
						setRefreshTableValue(refreshTableValue + 1)
					}
				/>

				<ConfirmationModal
					confirmationModalOpen={confirmationModalOpen}
					setConfirmationModalOpen={setConfirmationModalOpen}
					setResultsRows={setResultsRows}
					lockTable={() =>
						setLoadingTableValue(loadingTableValue + 1)
					}
					refreshTable={() =>
						setRefreshTableValue(refreshTableValue + 1)
					}
				/>

				<ResultsModal
					resultsModalOpen={resultsModalOpen}
					setResultsModalOpen={setResultsModalOpen}
					resultsRows={resultsRows}
					setResultsRows={setResultsRows}
				/>
			</Base>
			<br />
		</ThemeProvider>
	);
};

export default PendingApprovals;
